import { render, staticRenderFns } from "./rewardClubRankEdit.vue?vue&type=template&id=4053950d&scoped=true&"
import script from "./rewardClubRankEdit.vue?vue&type=script&lang=js&"
export * from "./rewardClubRankEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4053950d",
  null
  
)

export default component.exports